<template>
	<div class="box">
		<!-- 公共头部 -->
		<top_box></top_box>
		<!-- 轮播>1200 -->
		<div class="Rotation">
			<div class="block">
				<el-carousel :loop="true" :interval="6000" trigger="click" height="730px">
					<el-carousel-item v-for="(item, index) in banner_list" :key="index">
						<img :src="item.image" alt="" @click="commodity_info(item)">
					</el-carousel-item>
				</el-carousel>
			</div>
		</div>
		<!-- 轮播<1200 -->
		<div class="Rotation1 Rotation">
			<div class="block">
				<el-carousel :loop="true" :interval="6000" trigger="click">
					<el-carousel-item v-for="(item, index) in banner_list" :key="index">
						<img :src="item.image" alt="" @click="commodity_info(item)">
					</el-carousel-item>
				</el-carousel>
			</div>
		</div>
		
		<!-- 搜索 -->
		<div class="search">
			<div class="search_left">
				<div class="inpunt_box">
					<el-input :placeholder="$t('m.home_10')" v-model="value">
						<i slot="prefix" style="display: flex;align-items: center;">
							<img 
							@click="confirm1" 
							class="header-icon" 
							style="width:16px;height:16px;cursor:pointer"
							src="../static/images/sousuoicon.png" alt="" />
						</i>
					</el-input>
					<span class="search_btn" @click="confirm1">{{$t('m.home_01')}}</span>
				</div>
			</div>
			<div class="search_right">
				<div class="label pointer" @click="roll(1)">
					<div class="label_main">
						<img src="../static/images/pinpai.png" alt="">
					</div>
					<div class="label_text">{{$t('m.home_02')}}</div>
				</div>
				<div class="label pointer" @click="roll(2)">
					<div class="label_main">
						<img src="../static/images/xinwen.png" alt="">
					</div>
					<div class="label_text">{{$t('m.home_03')}}</div>
				</div>
				<div class="label pointer" @click="roll(22)">
					<div class="label_main">
						<img style="width: 0.8rem;" src="../static/images/caozuorizhi.png" alt="">
					</div>
					<div class="label_text">{{$t('m.home_033')}}</div>
				</div>
				<div class="label pointer" @click="roll(3)">
					<div class="label_main">
						<img src="../static/images/lianxi.png" alt="">
					</div>
					<div class="label_text">{{$t('m.home_04')}}</div>
				</div>
			</div>
		</div>
		<!-- 品牌列表 -->
		<div class="brand wow animate__animated animate__fadeInUp" id="div1">
			<div class="title">
				<div class="en" v-if="is_en=='false'">
					BRAND &nbsp;&nbsp; LIST
				</div>
				<div class="cn" v-if="is_en=='false'">
					<div class="cn_left">{{$t('m.home_02')}}</div>
					<div class="cn_right">{{$t('m.home_05')}} -</div>
				</div>
				<div class="cn" v-if="is_en=='true'">
					<div class="cn_left">BRAND &ensp;</div>
					<div class="cn_right">LIST -</div>
				</div>
			</div>
			<div class="brand_main flex f-ct">
				<!-- 左边箭头 -->
				<div class="jiantou" @click="Slideleft()">
					<div class="jiantouicon pointer">
						<img src="../static/images/jiantouzuo.png" alt="">
						<img src="../static/images/jiantouzuo1.png" alt="">
					</div>
				</div>
				<!-- 内容 -->
				<div class="list_box">
					<el-carousel indicator-position="none" :interval="6000" height="560px" ref="brandList" arrow="never"
						:loop="true">
						<el-carousel-item v-for="(item_f, index_f) in brand_list" :key="index_f">
							<div class="list flex f-ct f-w">
								<div class="item pointer" v-for="(item, index) in item_f" :key="index"
									@click="confirm(item)">
									<img :src="item.img" alt="">
								</div>
							</div>
						</el-carousel-item>
					</el-carousel>
				</div>
				<!-- 右边箭头 -->
				<div class="jiantou" @click="Slideright()">
					<div class="jiantouicon pointer">
						<img src="../static/images/jiantouyou1.png" alt="">
						<img src="../static/images/jiantouyou.png" alt="">
					</div>
				</div>
			</div>
		</div>
		<!-- 新闻资讯 -->
		<div class="Journalism wow animate__animated animate__fadeInUp" id="div2">
			<!-- 标题 -->
			<div class="Journalism_box">
				<div class="title">
					<div class="en" v-if="is_en=='false'">
						PRONDUCT
					</div>
					<div class="cn" v-if="is_en=='false'">
						<!-- <div class="cn_left">{{$t('m.home_06')}}</div> -->
						<div class="cn_right">{{$t('m.home_07')}} -</div>
					</div>
					<div class="cn" v-if="is_en=='true'">
						<!-- <div class="cn_left">NEWS&ensp;</div> -->
						<div class="cn_right">PRONDUCT -</div>
					</div>
				</div>
			</div>
			<!-- 新闻资讯  PC 版本 -->
			<div class="news_banner">
				<div class="recommend pointer" @click="joum_info(item.id)" v-for="(item,index) in news_list" :key="index">
					<div class="list">
						<div class="item">
							<div class="item_info">
								<div class="item_info_title">{{ item.title }}</div>
								<div class="item_info_text">
									{{ item.desc }}
								</div>
								<div class="item_info_foot">
									<div class="time">{{$t('m.home_17')}}：{{ item.publish_time }}</div>
									<div class="chakan ">
										<div class="chakan">- {{$t('m.home_11')}}</div>
										<img src="../static/images/jiantou.png" alt="">
									</div>
								</div>
							</div>
							<div class="item_img">
								<img :src="item.thumb" alt="">
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 新闻资讯  H5 版本 -->
			<div class="news_banner_h5">
				<div class="item" @click="joum_info(item.id)" v-for="(item,index) in news_list" :key="index">
					<div class="l">
						<img :src="item.thumb" alt="">
					</div>
					<div class="flex">
						<div class="r">
							<p class="tit line1">{{ item.title }}</p>
							<p class="txt line2">{{ item.desc }}</p>
						</div>
					</div>
					<div class="timebox flex f-ct f-bt">
						<p>{{$t('m.home_17')}}：{{ item.publish_time }}</p>
						<p>- {{$t('m.home_11')}}</p>
					</div>
				</div>
			</div>
		</div>
		<!-- 联系我们 -->
		<div class="contact wow animate__animated animate__fadeInUp" id="div3">
			<div class="title">
				<div class="en" v-if="is_en=='false'">
					CONTACT &nbsp;&nbsp; US
				</div>
				<div class="cn" v-if="is_en=='false'">
					<div class="cn_left">{{$t('m.home_08')}}</div>
					<div class="cn_right">{{$t('m.home_09')}} -</div>
				</div>
				<div class="cn" v-if="is_en=='true'">
					<div class="cn_left">CONTACT&ensp;&ensp;</div>
					<div class="cn_right">US -</div>
				</div>
			</div>
			<div class="contact_main">
				<div class="contact_main_left">
					<div class="contact_title">{{ info_data.website_name }}</div>
					<div class="contact_text">{{$t('m.home_12')}}：{{ info_data.address }}</div>
					<div class="contact_text">{{$t('m.home_13')}}：{{ info_data.phone }}</div>
					<div class="contact_text">{{$t('m.home_14')}}：{{ info_data.email }}</div>
				</div>
				<div class="contact_main_right">
					<div class="form_inp">
						<div class="inp_item">
							<div class="inp_"><input :placeholder="$t('m.home_15')" v-model="param.name"></div>
						</div>
						<div class="inp_item">
							<div class="inp_"><input :placeholder="$t('m.home_14')" v-model="param.email"></div>
						</div>
						<div class="inp_item">

							<div class="inp_"><input :placeholder="$t('m.home_13')" v-model="param.phone"></div>
						</div>
					</div>
					<div class="form_inp">
						<div class=" inp_item1">

							<div class="inp_"><input :placeholder="$t('m.home_16')" v-model="param.content"></div>
						</div>
					</div>
					<div class="form_btn">
						<el-button type="danger" @click="Submit">{{$t('m.home_18')}}</el-button>
					</div>
				</div>
			</div>
		</div>

		<!-- 公共底部 -->
		<fot_box></fot_box>
	</div>
</template>
<script>
	import top_box from '../components/header_top'
	import fot_box from '../components/foot'
	import encryption from '@/utils/encryption.js'
	export default {
		components: {
			top_box,fot_box
		},
		data() {
			return {
				is_en: 'false',
				show1: false,
				show2: true,
				show3: false,
				show4: true,
				info_data: {},
				value: '',
				user_data: {},
				banner_list: [], //轮播图
				param: {
					name: '',
					email: '',
					phone: '',
					content: ''
				},
				news_list: [], //新闻数组
				brand_list: [], //品牌数组
				news_banner_h: '1170px',
			}
		},
		mounted() {
			let user_data = JSON.parse(localStorage.getItem('user_data'))
			this.user_data = user_data
			// console.log(user_data)
			this.is_en = this.$t('m.is_en')
			// console.log(this.is_en)
			this.getData()
			this.getweb_info()
		},
		methods: {
			// 轮播跳转商品页
			commodity_info(item) {
				this.$router.push({
					path: '/MallCenter?value=' + item.link
				})
			},
			// 获取页面主信息
			getweb_info() {
				let param = {}
				let sing = encryption.getSing(param)
				this.$api.web_info(param, sing).then((res) => {
					if (res.data.code == 1) {
						this.info_data = res.data.data
					}
				})
			},
			//联系我们
			Submit() {
				if (!this.user_data) {
					this.$message.warning(this.$t('m.MallCenter_22'));
					setTimeout(() => {
						this.$router.push({
							path: '/account/login'
						})
					}, 2000)
					return
				}
				let param = this.param
				let user_data = JSON.parse(localStorage.getItem('user_data'))
				param.user_id = user_data.id || ''
				let sing = encryption.getSing(param)
				this.$api.contact_us(param, sing).then((res) => {
					if (res.data.code == 1) {
						this.$message.success(this.$t('m.home_19'))
					}
				})
			},
			// 品牌轮播上一页
			Slideleft() {
				console.log(1)
				this.$refs.brandList.prev()
			},
			// 品牌轮播下一页
			Slideright() {
				console.log(2)
				this.$refs.brandList.next()
			},
			// 搜索右边的按钮
			roll(id) {
				
				if(id==22){
					this.$router.push({
						path: '/caozuo'
					})
				}else{
					window.location.hash = '#div' + id
				}
			},
			// 获取首页信息
			getData() {
				var that = this
				this.$api.index().then((res) => {
					if (res.data.code == 1) {
						let data = res.data.data || []
						this.banner_list = data.banner_list || []
						// 处理品牌
						if(document.body.clientWidth>1200){
							var arr = []
							for (var i = 0; i < data.brand_list.length; i += 24) {
								arr.push(data.brand_list.slice(i, i + 24));
							}
						}else{
							var arr = []
							for (var i = 0; i < data.brand_list.length; i += 6) {
								arr.push(data.brand_list.slice(i, i + 6));
							}
						}
						this.brand_list = arr
						// 处理新闻
						this.news_list = data.news_list || []
						this.news_list.forEach(item => {
							item.publish_time = this.$common.timetrans(item.publish_time, 0, '/', '/', '')
						})
					}
				})
			},
			// 搜索跳商城
			confirm1() {
				this.$router.push({
					path: '/MallCenter?value=' + this.value
				})
			},
			// 品牌跳商城
			confirm(item) {
				this.$router.push({
					path: '/MallCenter?id=' + item.id || 0
				})
			},
			// 跳转新闻详情
			joum_info(id) {
				this.$router.push({
					path: '/joum_info?id=' + id
				})
			}
		}
	}
</script>

<style scoped lang="scss">
// 宽度小于1200px
// @media screen and (min-width: 1200px){
	// 修改部分
	.brand_main {
		.jiantou {
			opacity: 0;
			z-index: -1;
			transition: 0.4s;
		}
		&:hover {
			.jiantou {
				opacity: 1;
				z-index: 1;
				transition: 0.4s;
			}
		}
		.list_box {
			width: 100%;
			padding: 0 30px;
			.list {
				margin: 0 auto;
				display: flex;
				flex-wrap: wrap;
				// margin: 0 30px;
				.item {
					width: 190px;
					height: 90px;
					margin: 0 10px;
					margin-top: 20px;
					border: 2px solid #e5e5e5;
					display: flex;
					align-items: center;
					justify-content: center;
					border-radius: 4px;

					img {
						height: 60px;
					}
				}
			}
		}
	}
	.news_banner {}
	// 修改部分
	.box {
		// min-width: 1500px;
	}
	.title {
		padding: 0 90px;
		display: flex;

		flex-direction: column;

		.en {
			color: #7b7d84;
			width: 100%;

		}

		.cn {
			display: flex;
			align-items: center;
			font-weight: bold;
			font-size: 42px;

			.cn_left {
				color: #2e3341;
			}

			.cn_right {
				color: #ef5843;
			}
		}
	}

	.contact {
		width: 100%;
		padding: 50px 12%;
		margin: 0 auto;
		margin-top: 15px;
		background-color: #fff;
		// border-bottom: 7px solid #ea534a;
		background-image: linear-gradient(180deg, #fff 50%, #fdefee 90%);

		.contact_main {
			display: flex;
			width: calc(100% - 180px);
			margin: 0 auto;
			display: flex;
			justify-content: space-between;

			.contact_main_left {
				width: 35%;
				margin-top: 40px;


				.contact_title {
					font-size: 24px;
					// font-weight: bold;
				}

				.contact_text {
					margin-top: 0.5rem;
				}

				.contact_icons {
					display: flex;
					align-items: center;
					margin-top: 30px;

					img {
						width: 30px;
						height: 30px;
						margin-right: 10px;
					}
				}
			}

			.contact_main_right {
				margin-top: 40px;
				width: 60%;

				display: flex;
				flex-direction: column;
				justify-content: space-between;

				.form_inp {
					display: flex;
					align-items: center;
					justify-content: space-between;

					.inp_item1 {
						height: 40px;
					}

					.inp_text {
						line-height: 30px;
						width: 70px;

					}

					.inp_item1 {
						width: 100%;
						display: flex;
						align-items: center;
						border-bottom: 2px solid #a8a6a6;
						height: 46px;

						input {
							border: 0 !important;

							width: 100%;
							height: 40px;
							background-color: transparent;
							width: 500px;
							outline: none;
							font-size: 15px;
						}
					}

					.inp_item {
						border-bottom: 1px solid #181818;
						display: flex;
						align-items: center;
						height: 46px;

						width: 30%;


						input {
							border: 0 !important;

							font-size: 15px;
							height: 40px;
							background-color: transparent;
							outline: none;
						}


					}


				}

				.form_btn {
					width: 100%;
					display: flex;
					justify-content: center;

					.el-button {
						width: 150px !important;
						height: 50px !important;
						background-color: #ef5843;
						font-weight: bold;

						padding: 0 !important;


					}
				}

			}
		}
	}

	.Journalism {
		width: 100%;
		padding: 50px 0 10px 0;
		margin: 0 auto;
		margin-top: 15px;
		background-color: #fff;

		.Journalism_box {
			padding: 0 12%;
		}

		.recommend:hover {
			background-color: #fff3f2 !important;
			transition: 0.3s;
			// width: calc(100% - 2px) !important;

		}

		.recommend:hover {

			.item {
				border-left: 2px solid #fff3f2;
				transition: 0.3s;
			}

		}

		.recommend {
			transition: 0.3s;

			margin: 0 auto;
			margin-top: 40px;
			background-color: #fff;
			padding: 0 12%;
			height: auto;
			display: flex;
			align-items: center;

			.item {

				height: 308px;
				border-left: 2px solid #808080;
				width: 100%;
				display: flex;
				align-items: center;
				margin-top: 0 !important;
				justify-content: space-between;

				.item_info {
					max-height: 308px;
					padding: 0 50px;
					display: flex;
					justify-content: center;
					flex-direction: column;

					.item_info_title {
						font-size: 22px;
						font-weight: bold;
						color: #ef5843;
						letter-spacing: 2px;
					}

					.item_info_text {
						color: #697185;
						margin-top: 30px;
						letter-spacing: 3px;





					}

					.item_info_foot {
						display: flex;
						align-items: center;
						justify-content: space-between;
						margin-top: 50px;

						.chakan {
							color: #ef5843;

						}

						.time {
							font-weight: bold;
						}
					}
				}

				.item_img {
					width: 478px;
					height: 308px;

					img {
						width: 478px;
						height: 308px;
					}
				}
			}
		}

		.list {
			width: calc(100% - 180px);
			margin: 0 auto;

			.slide {
				margin-top: 30px;
				display: flex;
				align-items: center;

				justify-content: center;

				.slide_box {
					display: flex;
					align-items: center;
				}

				.circle {
					width: 12px;
					height: 12px;
					margin: 0 5px;
					border-radius: 50%;
					background-color: #ef5843;
				}

				.Selected {
					background-color: #d6d6d6;
				}
			}

			.item {
				margin-top: 40px;
				height: 308px;
				width: 100%;
				display: flex;
				align-items: center;
				border-left: 2px solid #808080;
				justify-content: space-between;

				.item_info {
					flex: 1;
					padding: 0 50px;
					display: flex;
					justify-content: center;
					flex-direction: column;

					.item_info_title {
						font-size: 22px;
						font-weight: bold;
						letter-spacing: 2px;
					}

					.item_info_text {
						color: #697185;
						margin-top: 30px;
						letter-spacing: 3px;
						height: 110px;
						line-height: 170%;
					}

					.item_info_foot {
						display: flex;
						align-items: center;
						justify-content: space-between;
						margin-top: 50px;

						.chakan {
							color: #ef5843;
							display: flex;
							align-items: center;


							img {
								margin-left: 10px;
							}
						}

						.time {
							font-weight: bold;
						}
					}
				}

				.item_img {
					width: 478px;
					height: 308px;

					img {
						width: 478px;
						height: 308px;
					}
				}
			}
		}
	}

	.brand {
		width: 100%;
		padding: 50px 12.5%;
		margin: 0 auto;
		margin-top: 15px;
		background-color: #fff;

		.brand_main {
			width: 100%;
			margin-top: 30px;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.jiantou {
				width: 60px;

				.jiantouicon {
					width: 60px;
					height: 60px;
					border-radius: 50%;
					border: 1px solid #dedede;
					display: flex;
					align-items: center;
					justify-content: center;
					img {
						width: 19px;
						height: 7px;
						&:first-child{
							display: block;
						}
						&:last-child{
							display: none;
						}
					}
				}
				.jiantouicon:hover {
					border: 1px solid #ef5843;
					background-color: #ef5843;
					img{
						&:first-child{
							display: none;
						}
						&:last-child{
							display: block;
						}
					}
				}
			}
		}
	}

	.Rotation {
		width: 100%;
		height: 730px;
		position: relative;

		img {
			width: 100%;
			height: 730px;
		}



		.slide {
			position: absolute;
			left: 50%;
			top: 95%;
			transform: translate(-50%, -50%);



			display: flex;
			align-items: center;

			justify-content: center;

			.slide_box {
				display: flex;
				align-items: center;
			}

			.circle {
				width: 14px;
				height: 14px;
				margin: 0 4px;
				border-radius: 50%;
				background-color: #fff;
			}

			.Selected_style {
				background-color: #574e47;
			}


		}

		img {
			width: 100%;
			height: 730px;
		}

		.Rotation_text {
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
			color: #FFF;

			h1 {
				margin-top: 10px;
				font-size: 50px;
			}

			p {
				margin-top: 20px;
			}
		}

	}

	.search {
		width: 100%;
		height: 160px;
		display: flex;
		align-items: center;
		padding: 0 160px;
		justify-content: space-between;
		background-color: #fff;

		.search_left {
			// width: 65%;
			width: calc(65% - 100px);

			height: 74px;


			::v-deep .el-input__prefix {
				display: flex;
				margin-left: 20px;
			}

			::v-deep .el-input__inner {

				padding-left: 60px !important;
				font-size: 16px;
			}

			.inpunt_box {
				width: 100%;
				height: 74px;
				border-top-right-radius: 5px;
				border-bottom-right-radius: 5px;
				display: flex;
				align-items: center;

				.header-icon {
					margin-right: 4px;
					width: 24px !important;
					height: 24px !important;
				}

				::v-deep .el-input__inner {
					border: 0 !important;
					border-radius: 0;
					height: 74px;
					background-color: #f6f7fa;
				}

				::v-deep .el-input-group {
					border-top-right-radius: 5px;
					border-bottom-right-radius: 5px;
				}

				::v-deep .el-input-group__append {
					color: #fff;
					background-color: #ef5843;
					cursor: pointer;
					border: 0 !important;
					width: 100px;
					text-align: center;
					font-weight: bold;
					font-size: 16px;
					border-top-right-radius: 5px;
					border-bottom-right-radius: 5px;
				}
			}
		}

		.search_right {
			width: 360px;
			height: 74px;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.label {
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				white-space: nowrap;

				.label_main {
					width: 48px;
					height: 48px;
					background-color: #fceceb;
					border-radius: 4px;
					display: flex;
					align-items: center;
					justify-content: center;

					img {}
				}

				.label_text {
					margin-top: 6px;
					font-size: 16px;

					text-align: center;
				}
			}
		}
	}

	::v-deep .el-carousel__button {
		width: 12px;
		height: 12px;
		border-radius: 50%;


	}

	// ::v-deep .is-active button{
	//     background-color: #554e47 !important;

	// }
	::v-deep .el-carousel__indicators--horizontal {
		bottom: 30px !important;
	}

	.search_btn {
		display: block;
		font-size: 15px;
		color: #fff;
		background-color: #ef5843;
		cursor: pointer;
		border: 0 !important;
		width: 100px;
		text-align: center;
		font-weight: bold;
		font-size: 16px;
		border-top-right-radius: 5px;
		border-bottom-right-radius: 5px;
		height: 74px;
		line-height: 74px;
	}

	.item_info_text {
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-line-clamp: 1; // 控制多行的行数
		-webkit-box-orient: vertical;
	}
	.Rotation1{display: none;}
	.news_banner_h5{display: none;}
// }


// 宽度小于1200px
@media screen and (max-width: 1200px){
	.jiantou{
		.jiantouicon{
			img {
				&:first-child{
					display: block!important;
				}
				&:last-child{
					display: none!important;
				}
			}
		}
	}
	.Rotation{
		width: 100%;
		display: none;
		::v-deep .el-carousel__indicators {
			display: none;
		}
	}
	.Rotation1{
		display: block!important;
		height: auto;
		img{
			height: auto;
		}
		&::v-deep .el-carousel__container{
			height: 6.3rem;
		}
	}
	.search{
		display: block;
		height: auto;
		padding: 0 1rem;
		padding-top: 0.8rem;
		padding-bottom: 0.8rem;
		.search_left{
			width: 100%;
			height: 2.05rem;
			margin-bottom: 0.8rem;
			.inpunt_box{
				border-radius: 0.225rem;
				height: 2.05rem;
				overflow: hidden;
				::v-deep .el-input__prefix{
					margin-left: 0.5rem;
					i{
						img{
							width: 0.8rem!important;
							height: 0.8rem!important;
						}
					}
				}

				.search_btn{
					height: 2.05rem;
					line-height: 2.05rem;
					font-size: 0.6rem;
				}
				::v-deep .el-input__inner {
					border: 0 !important;
					border-radius: 0;
					height: 2.05rem;
					font-size: 0.6rem;
					padding-left: 2.3rem!important;
					background-color: #f6f7fa;
				}
			}
		}
		.search_right{
			width: 100%;
			padding: 0 0.4rem;
			padding-top: 0.45rem;
			height: auto;
			.label{
				.label_main{
					width: 2.1rem;
					height: 2.1rem;
					padding: 0.5rem;
					img{
						width: 100%;
					}
				}
				.label_text{
					margin-top: 0.4rem;
					font-size: 0.7rem;
				}
			}
		}
	}
	.brand{
		padding: 0.6rem;
		.title{
			padding: 0;
			.en{
				font-size: 0.65rem;
			}
			.cn{
				font-size: 0.95rem;
			}
		}
		.brand_main{
			padding: 0.5rem 0;
			margin-top: 0.5rem;
			.list_box{
				padding: 0 0.6rem!important;
				::v-deep .el-carousel__container{
					height: 12rem!important;
				}
				.list{
					justify-content: space-between;
					.item{
						width: 49%!important;
						height: 3.65rem;
						margin: 0!important;
						margin-bottom: 0.5rem!important;
						padding: 0.3rem;
						overflow: hidden;
						img{
							// margin: 0.3rem;
							width: 100%;
							height: auto!important;
						}
					}
				}
			}
			.jiantou{
				opacity: 1;
				z-index: 1;
				width: auto;
				.jiantouicon{
					width: 1.5rem;
					height: 1.5rem;
					&:hover{
						border: 1px solid #ddd;
						background-color: #fff;
					}
				}
			}
		}
	}
	.Journalism{
		padding: 0.6rem;
		.Journalism_box{
			padding: 0;
			.title{
				padding: 0;
				.en{
					font-size: 0.65rem;
				}
				.cn{
					font-size: 0.95rem;
				}
			}
		}
		.news_banner{
			display: none;
		}
		.news_banner_h5{
			display: block;
			margin-top: 0.6rem;
			padding-bottom: 0.2rem;
			// padding: 0.6rem 0;
			display: flex;
			align-content: center;
			flex-wrap: wrap;
			justify-content: space-between;
			.item{
				border-bottom: 0.025rem solid #ddd;
				padding: 0.5rem 0;
				width: 8.5rem;
				// &:last-child{
				// 	border-bottom: none;
				// }
				.l{
					// width: 4rem;
					// height: 4rem;
					// margin-right: 0.5rem;
					img{
						display: block;
						width: 8.5rem;
						height: 8.5rem;
						// height: 4rem;
						border-radius: 0.2rem;
					}
				}
				.r{
					// width: calc(100% - 4.5rem);
					width: 100%;
					padding-right: 0.2rem;
					.tit{
						color: #ef5843;
						font-size: 0.85rem;
					}
					.txt{
						margin-top: 0.2rem;
						font-size: 0.55rem;
						font-weight: normal;
						color: #333;
					}

				}
				.timebox{
					margin-top: 0.4rem;
					font-size: 0.45rem;
					color: #666;
					p{
						&:last-child{
							color: #ef5843;
						}
					}
				}
			}
		}
	}
	.contact{
		padding: 0.6rem;
		.title{
			padding: 0;
			.en{
				font-size: 0.65rem;
			}
			.cn{
				font-size: 0.95rem;
			}
		}
		.contact_main{
			display: block;
			width: auto;
			.contact_main_left{
				width: 100%;
				margin-top: 1rem;
			}
			.contact_main_right{
				width: 100%;
				margin-top: 1rem;
				.form_inp{
					display: block;
					.inp_item1{
						border-bottom: 1px solid #999;
						height: auto;
						.inp_{
							width: 100%;
							input{
								height: 2.5rem;
								font-size: 0.6rem;
							}
						}
					}
					.inp_item{
						width: 100%;
						height: auto;
						border-bottom: 1px solid #999;
						.inp_{
							width: 100%;
							input{
								height: 2.5rem;
								font-size: 0.6rem;
							}
						}
					}
				}
				.form_btn{
					margin-top: 1rem;
				}
			}
		}
	}
}
</style>
